import styled from 'styled-components';
import { fade } from '@material-ui/core';

interface WarehouseCardCounterWrapperProps {
    isFilled?: boolean;
    isDanger?: boolean;
}

export const WarehouseCardCounterWrapper = styled.div<WarehouseCardCounterWrapperProps>`
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    align-items: center;
    padding: ${props => props.theme.spacing(1)}px ${props => props.theme.spacing(2)}px;
    border: 1px solid transparent;
    ${props => props.isFilled && `
        border: 1px solid ${props.theme.palette.success.main};
    `}
    background: ${props => props.isDanger ? props.theme.palette.error.light : fade(props.theme.palette.success.main, 0.16)};
    border-radius: 30px 10px 10px 10px;
    max-width: 500px;
    width: 100%;
`;
